
import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import DeleteModal from "../../../components/Modal/DeleteModal";

function Ingredients() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const [columns] = useState([
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Code") || "Code",
      accessorKey: "code",
    },
    {
      header: languageHelper("Name") || "Name",
      accessorKey: "name",
    },
    {
      header: languageHelper("Category") || "Category",
      // accessorKey: "category_name",
      cell: (cat) => cat.row.original.ingredient_category?.category_name,
    },
    {
      header: languageHelper("Purchase Unit Price") || "Purchase Unit Price",
      accessorKey: "purchase_price",
    },
    {
      header: languageHelper("Vat Percentage") || "Vat Percentage",
      accessorKey: "vat_percentage",
    },
    {
      header: languageHelper("Vat") || "Vat",
      accessorKey: "ing_vat",
    },
    {
      header:
        languageHelper("Total Amount with Vat") || "Total amount with Vat",
      accessorKey: "total_amount",
    },
    {
      header: languageHelper("Tax Method") || "Tax method",
      accessorKey: "tax_method",
    },
    {
      header:
        languageHelper("Alert Quantity/Amount") || "Alert Quantity/Amount",
      accessorKey: "alert_quantity",
    },
    {
      header: languageHelper("Unit") || "Unit",
      // accessorKey: "unit_name",
      cell: (unit) => unit.row.original.ingredient_unit?.unit_name,
    },
    {
      header: languageHelper("Added By") || "Added By",
      // accessorKey: "added_by",
      cell: (user) => user.row.original.user?.name,
    },
    {
      header: languageHelper("Actions") || "Actions",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ]);

  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`addEditIngredient/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        // Handle delete action
        setDeleteId(id);
      },
    },
  ];

  const buttonData = [
    {
      buttonText: languageHelper("Add Ingredient"),
      path: "addEditIngredient",
    },
    {
      buttonText: languageHelper("Upload Ingredient"),
      path: "uploadingredients",
    },
  ];

  const fetchData = useCallback(
    (csrfToken) => {
      axios
        .get(`${apiKey}/api/rms/admin/ingredients`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            outletId: user?.user.outlet_id,
          },
        })
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          setError(err.response.data.message);
        })
        .finally(() => setPageLoading(false));
    },
    [user?.token, user?.user.outlet_id],
  );

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/ingredients/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchData(); // Refetch data after successful delete
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    setPageLoading(true);

    handleCSRF(fetchData);
  }, [fetchData, user.token]);
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Ingredients")}
        buttonData={buttonData}
        error={error}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
      {deleteId && (
        <DeleteModal
          setIsOpen={setDeleteId}
          onDelete={() => handleDelete(deleteId)}
        />
      )}
    </main>
  );
}

export default Ingredients;
